function TicketStatus () {
  function filter (value) {
    switch (value) {
      case 'active':
        return 'Ativo'

      case 'validated':
        return 'Validado'

      case 'canceled':
        return 'Cancelado'

      default:
        return 'Desconhecido'
    }
  }

  return {
    filter
  }
}

export default TicketStatus
